module.exports = __webpack_public_path__ + "static/img/jfmxsm-title.145ae59b.png";